/**
 * Локали блокировки агента из карточки CRM (DEV-2087). Модульный словарь —
 * подмешивается в agentsRegistry.* поверх базовых локалей (см. locales/index.ts),
 * чтобы не править монолитные ru/en/vn.ts. Подписи статуса (status.blocked)
 * живут в базовой локали и здесь не дублируются.
 */

const ru = {
  agentsRegistry: {
    blocking: {
      block: 'Заблокировать',
      unblock: 'Разблокировать',
      blockTitle: 'Заблокировать агента?',
      unblockTitle: 'Разблокировать агента?',
      blockDescription:
        'Агент перестанет входить в личный кабинет: учётная запись деактивируется, активные сессии сбрасываются. Телеграм-бот тоже перестанет отдавать ему данные. Клиенты, сделки и история остаются на месте.',
      unblockDescription:
        'Учётная запись снова станет активной, агент сможет войти в личный кабинет и работать в телеграм-боте, статус станет «Активен».',
      blockImpact:
        'Написать в поддержку агент сможет только через телеграм-бота — в кабинет он больше не войдёт. Разблокировать можно в любой момент.',
      unblockImpact: 'Заблокировать снова можно в любой момент.',
      blockSuccess: 'Агент заблокирован',
      unblockSuccess: 'Агент разблокирован',
      blockError: 'Не удалось заблокировать агента',
      unblockError: 'Не удалось разблокировать агента',
    },
  },
}

const en = {
  agentsRegistry: {
    blocking: {
      block: 'Block',
      unblock: 'Unblock',
      blockTitle: 'Block this agent?',
      unblockTitle: 'Unblock this agent?',
      blockDescription:
        'The agent will no longer be able to sign in: the account is deactivated and active sessions are dropped. The Telegram bot stops serving them as well. Their clients, deals and history stay untouched.',
      unblockDescription:
        'The account becomes active again — the agent can sign in to the personal cabinet and use the Telegram bot, and their status becomes “Active”.',
      blockImpact:
        'The agent can only reach support through the Telegram bot — the cabinet is closed to them. You can unblock them at any time.',
      unblockImpact: 'You can block them again at any time.',
      blockSuccess: 'Agent blocked',
      unblockSuccess: 'Agent unblocked',
      blockError: 'Could not block the agent',
      unblockError: 'Could not unblock the agent',
    },
  },
}

const vn = {
  agentsRegistry: {
    blocking: {
      block: 'Chặn',
      unblock: 'Bỏ chặn',
      blockTitle: 'Chặn đại lý này?',
      unblockTitle: 'Bỏ chặn đại lý này?',
      blockDescription:
        'Đại lý sẽ không đăng nhập được nữa: tài khoản bị vô hiệu hoá và các phiên đang mở bị huỷ. Bot Telegram cũng ngừng cung cấp dữ liệu. Khách hàng, giao dịch và lịch sử vẫn được giữ nguyên.',
      unblockDescription:
        'Tài khoản hoạt động trở lại: đại lý đăng nhập được vào tài khoản cá nhân và dùng bot Telegram, trạng thái chuyển thành «Đang hoạt động».',
      blockImpact:
        'Đại lý chỉ có thể liên hệ hỗ trợ qua bot Telegram — tài khoản cá nhân đã đóng với họ. Bạn có thể bỏ chặn bất cứ lúc nào.',
      unblockImpact: 'Bạn có thể chặn lại bất cứ lúc nào.',
      blockSuccess: 'Đã chặn đại lý',
      unblockSuccess: 'Đã bỏ chặn đại lý',
      blockError: 'Không thể chặn đại lý',
      unblockError: 'Không thể bỏ chặn đại lý',
    },
  },
}

export const agentBlockingMessages = { ru, en, vn }
